import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/45.png';
const _withScopeId = n => (_pushScopeId("data-v-4da3ffd8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-4da3ffd8>填写真实信息</div><div class=\"step\" data-v-4da3ffd8><div data-v-4da3ffd8>1.填写学校</div><img src=\"" + _imports_0 + "\" data-v-4da3ffd8><div data-v-4da3ffd8>2.选择年级班级</div><img src=\"" + _imports_0 + "\" data-v-4da3ffd8><div class=\"active\" data-v-4da3ffd8>3.填写姓名</div></div>", 2);
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "cells"
};
const _hoisted_5 = {
  href: "javascript: void(0)",
  class: "cell"
};
const _hoisted_6 = {
  class: "left"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "姓名", -1));
import { onMounted, reactive, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getLocalPid } from "../../../libs/util";
import { userSetClass } from "../../../api/index";
import { ElMessage } from "element-plus";
export default {
  __name: 'studentMes_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const formData = reactive({
      data: {}
    });
    const safeMes = computed(() => store.state.safeMes);
    const userInfo = computed(() => store.state.userInfo || {});
    const next = () => {
      userSetClass(JSON.stringify(formData.data)).then(res => {
        let data = res.data;
        if (data.code) return ElMessage.error(data.msg);
        store.commit("destoryPreUserMes");
        if (route.query.type) {
          store.dispatch("getUserInfo", "article").then(() => {
            console.log(6666);
          });
          router.push({
            name: "ability",
            query: {
              type: formData.data.school_type
            }
          });
        } else router.push({
          name: "my",
          query: {
            pid: getLocalPid()
          }
        });
        return ElMessage.success("设置成功");
      }).catch(err => {
        return ElMessage.error(JSON.stringify(err));
      });
    };
    onMounted(() => {
      console.log(route.params);
      if (Object.keys(route.params).length === 0) {
        router.push({
          name: "schoolMes"
        });
      }
      console.log(formData);
      formData.data = {
        ...safeMes.value,
        ...route.params,
        realname: userInfo.value.realname
      };
    });
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.data.realname = $event),
        placeholder: "请输入姓名"
      }, null, 512), [[_vModelText, formData.data.realname]])])])]), _createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        onClick: next,
        style: {
          "width": "80%",
          "margin": "1rem auto"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(route).query.type ? "保存并设置阅读能力" : "保存"), 1)]),
        _: 1
      })])])], 2);
    };
  }
};